import {ChangeDetectionStrategy, Component, Input, OnChanges} from '@angular/core';
import {Observable} from 'rxjs';

export interface ItemValueOverride {
    location: string;
    variation: string;
    attribute: string;
    value: string;
    baseValue: string;
    base: boolean;
}

export interface GroupedOverrides {
    variation: string;
    overrides: ItemValueOverride[];
}

@Component({
    selector: 'emm-value-overrides-card',
    templateUrl: './value-overrides-card.component.html',
    styleUrls: ['./value-overrides-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ValueOverridesCardComponent implements OnChanges {
    @Input() overrides: ItemValueOverride[] = [];
    @Input() isLoading$: Observable<boolean>;

    readonly displayedColumns: string[] = ['location', 'attribute', 'value'];
    groupedOverrides: GroupedOverrides[] = [];

    ngOnChanges(): void {
        this.groupedOverrides = this.groupByVariation(this.overrides);
    }

    private groupByVariation(overrides: ItemValueOverride[]): GroupedOverrides[] {
        const grouped = overrides.reduce((acc, override) => {
            if (!acc[override.variation]) {
                acc[override.variation] = [];
            }
            acc[override.variation].push(override);
            return acc;
        }, {} as Record<string, ItemValueOverride[]>);

        return Object.entries(grouped).map(([variation, overrides]) => ({
            variation,
            overrides
        }));
    }
}
